import React from 'react'
import { useTranslation } from 'react-i18next'
import PasswordForm from './passwordForm'
import ProfileForm from './profileForm'

interface ProfileFormValues {
  user: string
  name: string
}

interface PasswordFormValues {
  password: string
}

const Profile = () => {
  const { t } = useTranslation()

  const submitProfile = (values: ProfileFormValues) => {

  }

  const submitPassword = (values: PasswordFormValues) => {
  
  }

  return (
    <>
      <div>
        <span className="principal-title">{`${t('PROFILE')}`}</span>
        <ProfileForm onSubmit={submitProfile} user={''} name={''} />
        <PasswordForm
          onSubmit={submitPassword}
          user={''}
          password={''}
          newPassword={''}
          confirmNewPassword={''}
        />
      </div>
    </>
  )
}

export default Profile
